import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { SCRoutes } from 'src/config';
import { PageNotFound } from 'src/features/PageNotFound';
import { DashboardUsersCreate } from './DashboardUsersCreate';
import { DashboardUsersEdit } from './DashboardUsersEdit';
import { DashboardUsersHome } from './DashboardUsersHome';

type Props = {
  testID?: string;
};

export const DashboardUsers: React.FC<Props> = ({ testID = 'DashboardUsers' }) => {
  return (
    <Switch>
      <Route path={SCRoutes.dashboard.users.home} exact component={DashboardUsersHome} />
      <Route path={SCRoutes.dashboard.users.edit} component={DashboardUsersEdit} />
      <Route path={SCRoutes.dashboard.users.new} component={DashboardUsersCreate} />
      <Route component={PageNotFound} />
    </Switch>
  );
};
